export default __webpack_public_path__ + "0a397ca71a6dc18548536e9eb8f6a71e.png";